// Catálogos del expediente PagoConFiado que comparten dos pantallas. Los valores NO son libres:
// salen del catálogo de Fiado (`AppSelectionData_GT`) y el silo los valida contra el mismo listado.
import type { MonthlyIncome, Occupation } from './types';

/**
 * Ingreso mensual declarado. Lo preguntan el paso 02 (junto con la ocupación) y el paso 10 (dentro
 * del perfil transaccional): una sola lista para que las dos pantallas no se separen.
 *
 * Las etiquetas son topes, no montos exactos — así los redacta la app del cliente.
 */
export const MONTHLY_INCOME_OPTIONS: { value: MonthlyIncome; label: string }[] = [
    { value: '0', label: 'Nada' },
    { value: '10000', label: 'Menos de $10,000' },
    { value: '20000', label: 'Menos de $20,000' },
    { value: '50000', label: 'Menos de $50,000' },
    { value: '100000', label: 'Menos de $100,000' },
    { value: '150000', label: 'Más de $100,000' },
];

/** El mismo catálogo en pares `[valor, texto]`, como los pinta el `<select>` nativo del paso 10. */
export const MONTHLY_INCOME_PAIRS = MONTHLY_INCOME_OPTIONS.map(
    (o) => [o.value, o.label] as [string, string],
);

/**
 * Ocupación. La pregunta el paso 02 y también el paso 10: el comprador que llegó por facematch se
 * salta el 02, así que puede no tenerla en el expediente.
 */
export const OCCUPATION_OPTIONS: { value: Occupation; label: string }[] = [
    { value: 'EMPLOYED', label: 'Trabaja para una empresa' },
    { value: 'SELF_EMPLOYED', label: 'Trabaja por cuenta propia' },
    { value: 'STUDENT', label: 'Estudiante' },
    { value: 'HOMEMAKER', label: 'Labores del hogar' },
    { value: 'RETIRED', label: 'Jubilado o pensionado' },
    { value: 'UNEMPLOYED', label: 'Actualmente sin empleo' },
    { value: 'OTHER', label: 'Otra' },
];

/** El mismo catálogo en pares `[valor, texto]`, como los pinta el `<select>` nativo del paso 10. */
export const OCCUPATION_PAIRS = OCCUPATION_OPTIONS.map(
    (o) => [o.value, o.label] as [string, string],
);
